import { env } from '../config/env';

/** Dispatched on window after LMS credentials are validated and stored (refresh dashboard status). */
export const LMS_CALENDAR_UPDATED_EVENT = 'meetbot-lms-calendar-updated';

/**
 * Calls the FastAPI LMS validator. On success the backend updates public.users
 * (vit_username, vit_password encrypted, ics_feed_url).
 *
 * @param {{ userId: string, vitUsername: string, vitPassword: string }} params
 * @returns {Promise<{ ok: true, calendar_feed_url?: string, status?: string } | { ok: false, error?: string, detail?: string, clientError?: string, networkError?: boolean }>}
 */
export async function validateAndStoreLmsCredentials({ userId, vitUsername, vitPassword }) {
    const base = (env.backendBaseUrl || '').replace(/\/$/, '');
    if (!base) {
        return { ok: false, clientError: 'missing_backend_url' };
    }

    let data;
    try {
        // Matches backend_api.app.main: POST /api/lms/validate_and_store (JSON body per app.schemas.auth)
        const res = await fetch(`${base}/api/lms/validate_and_store`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                user_id: userId,
                vit_username: vitUsername.trim(),
                vit_password: vitPassword,
            }),
        });
        data = await res.json().catch(() => ({}));
        if (!res.ok) {
            const detail = data.detail != null ? String(data.detail) : res.statusText;
            return { ok: false, httpError: true, status: res.status, detail };
        }
    } catch (e) {
        return { ok: false, networkError: true, detail: e.message };
    }

    if (!data.ok) {
        return { ok: false, error: data.error || 'unknown', calendar_feed_url: data.calendar_feed_url };
    }

    return {
        ok: true,
        calendar_feed_url: data.calendar_feed_url,
        status: data.status,
    };
}
